var e=class{promise;resolve;reject;hasResolved=!1;constructor(){this.promise=new Promise((o,a)=>{this.resolve=s=>{this.hasResolved=!0,o(s)},this.reject=s=>{this.hasResolved=!1,a(s)}})}};export{e as a};
